export default __webpack_public_path__ + "static/media/cheers.1ddd8425.jpg";